import React, { useState } from 'react';
import { ImagePlus } from 'lucide-react';

/**
 * Image slot that degrades gracefully: renders the photo at `src` when the
 * file exists; otherwise shows a styled placeholder telling which photo
 * should be dropped there (path + description), so empty slots still look
 * intentional while the real photos are being collected.
 */
const SmartImage = ({ src, alt, label, className = '', imgClassName = '' }) => {
  const [failed, setFailed] = useState(false);

  return (
    <div className={'relative overflow-hidden ' + className}>
      {failed ? (
        <div className="ati-img-placeholder">
          <ImagePlus size={22} className="text-primary-400/70" />
          <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-primary-400/80">
            {src.replace('/media/img/', '')}
          </span>
          {label && (
            <span className="text-xs text-mist-500 max-w-[220px] leading-relaxed">{label}</span>
          )}
        </div>
      ) : (
        <img
          src={src}
          alt={alt || label || ''}
          loading="lazy"
          onError={() => setFailed(true)}
          className={'w-full h-full object-cover ' + imgClassName}
        />
      )}
    </div>
  );
};

export default SmartImage;
